import { useEffect, useState } from 'react';
import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { stringIsEmpty } from 'Util/TypeGuards';

export interface UserTypeTermsOverride {
	vehicle?: string;
	passenger?: string;
	freight?: string;
}

interface ApiResponse {
	vehicleTermsAndConditions?: string | null;
	passengerTermsAndConditions?: string | null;
	freightTermsAndConditions?: string | null;
}

export async function fetchUserTypeTermsOverride(userId: string): Promise<UserTypeTermsOverride> {
	const { data } = await axios.get<ApiResponse>(`${SERVER_URL}/api/user-display-names/terms`, {
		params: { userId },
	});
	return {
		vehicle: data.vehicleTermsAndConditions ?? undefined,
		passenger: data.passengerTermsAndConditions ?? undefined,
		freight: data.freightTermsAndConditions ?? undefined,
	};
}

/**
 * Fetches the per-booking-type T&C overrides defined on the customer's user type.
 * Returns an empty object for guests or when no overrides exist.
 */
export function useUserTypeTermsOverride(userId: string | undefined): UserTypeTermsOverride {
	const [overrides, setOverrides] = useState<UserTypeTermsOverride>({});

	useEffect(() => {
		if (stringIsEmpty(userId)) {
			setOverrides({});
			return;
		}
		fetchUserTypeTermsOverride(userId!)
			.then(setOverrides)
			.catch(() => setOverrides({}));
	}, [userId]);

	return overrides;
}
